import { SkinnableComponent, ComponentSkinProps } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useAssetHistoryLogic } from './AssetHistoryLogic';
import BasicAssetHistorySkin from './skins/BasicAssetHistorySkin';

/**
 * AssetHistory 컴포넌트의 스킨 시스템 정의
 */
export const AssetHistorySkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.ASSET_HISTORY,
  name: '자산 내역',
  category: 'financial',
  icon: '💰',
  options: [
    {
      type: 'text',
      label: '제목',
      key: 'title',
      default: '자산 내역'
    },
    {
      type: 'text',
      label: '빈 상태 메시지',
      key: 'emptyText',
      default: '자산 내역이 없습니다.'
    },
    {
      type: 'checkbox',
      label: '잔액 표시',
      key: 'showBalance',
      default: true
    },
    {
      type: 'checkbox',
      label: '입금 버튼 표시',
      key: 'showDepositButton',
      default: true
    },
    {
      type: 'checkbox',
      label: '출금 버튼 표시',
      key: 'showWithdrawButton',
      default: true
    },
    {
      type: 'checkbox',
      label: '환전 버튼 표시',
      key: 'showExchangeButton',
      default: true
    },
    {
      type: 'checkbox',
      label: 'P2P 전송 버튼 표시',
      key: 'showP2PButton',
      default: true
    },
    {
      type: 'checkbox',
      label: '필터 표시',
      key: 'showFilter',
      default: true
    },
    {
      type: 'number',
      label: '페이지당 항목 수',
      key: 'itemsPerPage',
      default: 10,
      min: 5,
      max: 50
    },
    {
      type: 'color',
      label: '주 색상',
      key: 'primaryColor',
      default: '#007bff'
    },
    {
      type: 'color',
      label: '성공 색상',
      key: 'successColor',
      default: '#28a745'
    },
    {
      type: 'color',
      label: '위험 색상',
      key: 'dangerColor',
      default: '#dc3545'
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicAssetHistorySkin as any
  },
  useLogic: useAssetHistoryLogic as any,
  defaultProps: {
    title: '자산 내역',
    emptyText: '자산 내역이 없습니다.',
    showBalance: true,
    showDepositButton: true,
    showWithdrawButton: true,
    showExchangeButton: true,
    showP2PButton: true,
    showFilter: true,
    itemsPerPage: 10,
    primaryColor: '#007bff',
    successColor: '#28a745',
    dangerColor: '#dc3545'
  }
};